<!-- This templates insert a chunck if the var is defined -->
<template>
  <v-list-item v-if="this.condition()">
    <v-list-item-content>
      <v-list-item-title>{{ this.prefix }}</v-list-item-title>
      <v-list-item-subtitle>{{
        this.displayText() + this.suffix
      }}</v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: "SimpleListItem",
  props: {
    var: { required: true },
    data: { required: true },
    field: { required: false },
    showifempty: { default: false },
    icon: {},
    prefix: {
      default: "",
    },
    suffix: {
      default: "",
    },
  },
  methods: {
    condition() {
      if (!this.var) {
        return false;
      }
      if (!this.data) {
        return false;
      }
      if (!(this.data in this.var)) {
        return false;
      }
      return this.showifempty || this.var[this.data];
    },
    displayText() {
      if (this.field && this.field == "mix") {
        return (
          this.var[this.data]["libelle"] +
          "(" +
          this.var[this.data]["valeur"] +
          ")"
        );
      }
      if (!this.field || !(this.field in this.var[this.data])) {
        return this.var[this.data];
      }
      return this.var[this.data][this.field];
    },
    displayIcon() {
      if (!this.icon) return "";
      return "fa fa-" + this.icon;
    },
  },
};
</script>
